import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Search from "@/pages/Search";
import FacilityDetail from "@/pages/FacilityDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import StateLanding from "@/pages/StateLanding";
import StatesIndex from "@/pages/StatesIndex";
import FacilityDashboard from "@/pages/FacilityDashboard";
import CaregiverDashboard from "@/pages/CaregiverDashboard";
import ForFacilities from "@/pages/ForFacilities";
import AdminDashboard from "@/pages/AdminDashboard";
import PlacementHelp from "@/pages/PlacementHelp";
import BillingReturn from "@/pages/BillingReturn";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import RequestVisitFAB from "@/components/RequestVisitFAB";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="min-h-[70vh]">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/search" element={<Search />} />
              <Route path="/facility/:id" element={<FacilityDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/states" element={<StatesIndex />} />
              <Route path="/state/:stateSlug" element={<StateLanding />} />
              <Route path="/for-facilities" element={<ForFacilities />} />
              <Route path="/placement-help" element={<PlacementHelp />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/billing/return" element={<BillingReturn />} />
              <Route
                path="/dashboard/admin"
                element={
                  <ProtectedRoute role="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/facility"
                element={
                  <ProtectedRoute role="facility">
                    <FacilityDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/caregiver"
                element={
                  <ProtectedRoute role="caregiver">
                    <CaregiverDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
          <RequestVisitFAB />
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
